import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { FormErrorDirective } from '@shared/directives/form-error.directive';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Component({
  selector: 'app-form-area',
  imports: [ReactiveFormsModule, CommonModule, FormErrorDirective],
  template: ` <div>
    <label [for]="id" class="block text-sm/6 font-medium text-gray-900 {{labelClass}}">{{ label }}</label>
    <div class="">
      <textarea
        [id]="id"
        [rows]="rows"
        [formControl]="control"
        [placeholder]="placeholder"
        (blur)="onTouched()"
        class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400
        focus:outline-1 focus:-outline-offset-1 focus:outline-focus/70 focus:shadow-sm sm:text-sm/6 transition duration-300 ease-in-out {{className}}"
        [ngClass]="{ 'outline-red-300 ': hasError }"
      ></textarea>
      <!-- <textarea name="about" id="about" rows="3" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"></textarea> -->
      <span appFormError [errors]="errors" [hidden]="!hasError" class="text-xs mt-1 text-red-400"></span>
    </div>
  </div>`,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormAreaComponent),
      multi: true
    }
  ]
})
export class FormAreaComponent implements ControlValueAccessor {
  private _control: FormControl = new FormControl();
  private _disabled = false;

  @Input() label!: string;
  @Input() id!: string;
  @Input() rows: number = 3;
  @Input() type: 'text' | 'email' | 'password' = 'text';
  @Input() className = '';
  @Input() labelClass = '';
  @Input() placeholder = '';
  @Input() set control(value: AbstractControl<any, any> | null) {
    this._control = (value as FormControl) ?? new FormControl();
  }

  get control(): FormControl {
    return this._control;
  }

  get hasError(): boolean {
    return this.control.invalid && this.control.touched;
  }

  get errors(): any {
    return this.control.errors || {};
  }

  // Implementación de ControlValueAccessor
  writeValue(value: any): void {
    if (value !== undefined) {
      this.control.setValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.control.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this._disabled = isDisabled;
    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }
  }

  // Función que se llamará cuando el campo pierda el foco
  onTouched = () => {};
}
